import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import axios from "axios";
import { handleApiError } from "@utils/errorHandler";
import { Dialog, Button, Image } from "hesus-ui-kit";
import PulseLoader from "react-spinners/PulseLoader";
import { ColumnButton } from "@utils/extra-style";
import Header from "./components/Header";
import AcceptanceContent from "./components/AcceptanceContent";

import {
  HeaderWrapper,
  Title,
  ButtonWrapper,
  FormBody,
  FlexRow,
  SectionContainer,
  GridRow,
  GridSubItem,
  NewAcceptanceButtonWrapper,
} from "./SolutionAcceptanceView.styled";
import closeIcon from "@icons/ic-close-white.svg";

const SolutionAcceptanceView = (props) => {
  const {
    t,
    solutionId,
    onClose,
    supplierName,
    centreName,
    onSolutionEditAcceptanceClick,
    setAcceptanceId,
    onSolutionAddAcceptanceClick,
  } = props;

  const [isLoading, setIsLoading] = useState(false);
  const [acceptanceData, setAcceptanceData] = useState([]);
  const [refreshAcceptanceData, setRefreshAcceptanceData] = useState(false);

  const fetchAcceptanceData = () => {
    setIsLoading(true);
    axios
      .get(`/solutions/${solutionId}/acceptances`)
      .then((response) => {
        if (response.data?.solutionAcceptance) {
          setAcceptanceData(response.data?.solutionAcceptance);
          setIsLoading(false);
        }
      })
      .catch((error) => handleApiError(error));
  };

  useEffect(() => {
    fetchAcceptanceData();
  }, []);

  useEffect(() => {
    if (refreshAcceptanceData) {
      setRefreshAcceptanceData(false);
      fetchAcceptanceData();
    }
  }, [refreshAcceptanceData]);

  const onSolutionAcceptanceAddClick = (id) => {
    setAcceptanceId(id);
    onSolutionAddAcceptanceClick();
  };

  return (
    <>
      <Dialog width="65rem">
        <div className="solution-acceptance-view">
          <HeaderWrapper>
            <Title>
              {t("SOLUTION_ACCEPTANCES_TITLE") +
                " - [" +
                supplierName +
                "] " +
                centreName}
            </Title>
            <Button
              onClick={onClose}
              styles={{
                backgroundColor: "transparent",
                border: "none",
                height: "auto",
                padding: 0,
                "&:hover": {
                  backgroundColor: "transparent",
                },
              }}
            >
              <Image
                src={closeIcon}
                alt="close Product price popup"
                styles={{ height: "25px", cursor: "pointer" }}
              />
            </Button>
          </HeaderWrapper>
          <FormBody>
            <FlexRow>
              <SectionContainer>
                <div>
                  <GridRow marginTop="0px">
                    <NewAcceptanceButtonWrapper>
                      <ColumnButton
                        border="#1bace4"
                        background="#1bace4"
                        padding="5px"
                        onClick={() => onSolutionAcceptanceAddClick(solutionId)}
                      >
                        {t("SOLUTION_ACCEPTANCES_NEW_ACTION")}
                      </ColumnButton>
                    </NewAcceptanceButtonWrapper>
                  </GridRow>
                  {isLoading && (
                    <div className="suggestions-list-loading">
                      <PulseLoader color="#1bace4" size={15} />
                    </div>
                  )}

                  {!isLoading &&
                    acceptanceData?.length > 0 &&
                    acceptanceData.map((acceptance, acceptanceIndex) => {
                      return (
                        <React.Fragment
                          key={`solution-acceptance-list-${acceptance.id}${acceptanceIndex}`}
                        >
                          <Header
                            data={acceptance}
                            solutionId={solutionId}
                            setRefreshAcceptanceData={setRefreshAcceptanceData}
                            onSolutionEditAcceptanceClick={
                              onSolutionEditAcceptanceClick
                            }
                            setAcceptanceIdForEdit={setAcceptanceId}
                          />
                          <AcceptanceContent data={acceptance} />
                        </React.Fragment>
                      );
                    })}
                  {!isLoading && acceptanceData?.length === 0 && (
                    <GridRow>
                      <GridSubItem
                        fontStyle="italic"
                        fontSize="16px"
                        color="#fff"
                        alignContent="center"
                      >
                        {t("NO_ACCEPTANCE")}
                      </GridSubItem>
                    </GridRow>
                  )}
                </div>
              </SectionContainer>
            </FlexRow>
          </FormBody>

          <ButtonWrapper>
            <Button
              styles={{
                color: "#333",
                background: "#fff",
                marginRight: "0.32rem",
                border: "1px solid #ccc",
                "&:hover": {
                  backgroundColor: "#ccc",
                },
              }}
              onClick={onClose}
            >
              {t("CLOSE")}
            </Button>
          </ButtonWrapper>
        </div>
      </Dialog>
    </>
  );
};

SolutionAcceptanceView.propTypes = {
  t: PropTypes.func.isRequired,
  id: PropTypes.number,
};

SolutionAcceptanceView.defaultProps = {
  id: null,
};

export default withTranslation()(SolutionAcceptanceView);
